<template>
  <div class="reg_form_box">
    <template v-if="form_step == 1">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>Which of the following best describes you?</h1>
      </div>
      <form action="#">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio1"
                name="relationship_with_property"
                v-model="relationship_with_property"
                class="custom-control-input"
                value="agent"
              />
              <label class="custom-control-label" for="customRadio1">Agent</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="relationship_with_property"
                v-model="relationship_with_property"
                class="custom-control-input"
                value="builder"
              />
              <label class="custom-control-label" for="customRadio2">Builder Representative</label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form_submit_button">
              <button type="button" :disabled="step_one_invalid" @click="handleFormStep">
                Continue
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-else-if="form_step == 2">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>Let’s collect builder information.</h1>
      </div>
      <form>
        <div class="sell_home_form_box">
          <div class="sell_home_form" id="form3">
            <div class="form-row">
              <div class="col-md-12 mb-4">
                <div class="input_star">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Builder name"
                    name="builder_name"
                    v-model="builder_name"
                  />
                </div>
              </div>
              <div class="col-md-12 mb-4">
                <div class="input_star">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Builder Address (Including City)"
                    name="builder_address"
                    v-model="builder_address"
                  />
                </div>
              </div>
              <div class="col-md-12 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Project Name"
                  name="project_name"
                  v-model="project_name"
                />
              </div>
              <div class="col-md-12 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Project City"
                  name="project_city"
                  v-model="project_city"
                />
              </div>
              <div class="col-md-6 mb-4">
                <div class="input_star">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="State/Province"
                    name="state"
                    v-model="state"
                  />
                </div>
              </div>
              <div class="col-md-6 mb-4">
                <div class="input_star">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Zip/Postal Code"
                    name="zip"
                    v-model="zip"
                  />
                </div>
              </div>
              <div class="col-md-6 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Project Neighborhood"
                  name="neighborhood"
                  v-model="neighborhood"
                />
              </div>
              <div class="col-md-6 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Project closest intersection"
                  name="intersection"
                  v-model="intersection"
                />
              </div>
              <div class="col-md-12">
                <div class="form_submit_button">
                  <button type="button" class="form_back prev_form1" @click="backFormStep">
                    <span>
                      <i class="fas fa-chevron-left"></i>
                    </span> Back
                  </button>
                  <button type="button" class="next_form1" :disabled="step_two_invalid" @click="handleFormStep">
                    Continue
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-else-if="form_step == 3">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>Let’s collect some more builder information.</h1>
      </div>
      <form>
        <div class="sell_home_form_box">
          <div class="sell_home_form" id="form3">
            <div class="form-row">
              <div class="col-md-12 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Builder sales center address"
                  name="sales_center_address"
                  v-model="sales_center_address"
                />
              </div>
              <div class="col-md-12 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Builder website (e.g. https://redbuyers.com)"
                  name="builder_website"
                  v-model="builder_website"
                />
              </div>
              <div class="col-md-12 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Name of architect"
                  name="architect"
                  v-model="architect"
                />
              </div>
              <div class="col-md-12 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Marketing company"
                  name="marketing_company"
                  v-model="marketing_company"
                />
              </div>
              <div class="col-md-12 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Interior designers"
                  name="interior_designers"
                  v-model="interior_designers"
                />
              </div>
              <div class="col-md-12 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Sales company or brokerage"
                  name="brokerage"
                  v-model="brokerage"
                />
              </div>
              <div class="col-md-12">
                <div class="form_submit_button">
                  <button type="button" class="form_back prev_form1" @click="backFormStep">
                    <span>
                      <i class="fas fa-chevron-left"></i>
                    </span> Back
                  </button>
                  <button type="button" class="next_form1" :disabled="step_three_invalid" @click="handleFormStep">
                    Continue
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-else-if="form_step == 4">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>Type of Home</h1>
      </div>
      <form action="#">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio1"
                name="type_of_home"
                v-model="type_of_home"
                class="custom-control-input"
                value="New Construction"
              />
              <label class="custom-control-label" for="customRadio1">New Construction</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="type_of_home"
                v-model="type_of_home"
                class="custom-control-input"
                value="Assignment Sale"
              />
              <label class="custom-control-label" for="customRadio2">Assignment Sale</label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form_submit_button">
              <button type="button" class="form_back prev_form1" @click="backFormStep">
                <span>
                  <i class="fas fa-chevron-left"></i>
                </span> Back
              </button>
              <button type="button" :disabled="step_four_invalid" @click="handleFormStep">
                Continue
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-else-if="form_step == 5">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>What is Status of the building?</h1>
      </div>
      <form action="#">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio1"
                name="building_status"
                v-model="building_status"
                class="custom-control-input"
                value="Inventory sale"
              />
              <label class="custom-control-label" for="customRadio1">Inventory sale</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="building_status"
                v-model="building_status"
                class="custom-control-input"
                value="Pre-Construction"
              />
              <label class="custom-control-label" for="customRadio2">Pre-Construction</label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form_submit_button">
              <button type="button" class="form_back prev_form1" @click="backFormStep">
                <span>
                  <i class="fas fa-chevron-left"></i>
                </span> Back
              </button>
              <button type="button" :disabled="step_five_invalid" @click="handleFormStep">
                Continue
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-else-if="form_step == 6">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>Let’s get the price informations</h1>
      </div>
      <form action="#">
        <div class="sell_home_form_box">
          <div class="sell_home_form" id="form3">
            <div class="form-row">
              <div class="col-md-6 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Min price"
                  name="min_price"
                  v-model="min_price"
                />
              </div>
              <div class="col-md-6 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Max price"
                  name="max_price"
                  v-model="max_price"
                />
              </div>
              <div class="col-md-12 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Total number of units"
                  name="units"
                  v-model="units"
                />
              </div>
              <div class="col-md-12 mb-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Maintenance charge"
                  name="maintenance_charge"
                  v-model="maintenance_charge"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="reg_form_box_title agent_form_pat_title">
          <h1>Parking Included?</h1>
        </div>
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio1"
                name="parking"
                v-model="parking"
                class="custom-control-input"
                value="1"
              />
              <label class="custom-control-label" for="customRadio1">Yes</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="parking"
                v-model="parking"
                class="custom-control-input"
                value="0"
              />
              <label class="custom-control-label" for="customRadio2">No</label>
            </div>
          </div>
          <div class="col-md-12 mb-4">
            <input
              type="text"
              class="form-control"
              placeholder="Price per square feet"
              name="price_per_sqft"
              v-model="price_per_sqft"
            />
          </div>
          <div class="col-md-12">
            <div class="form_submit_button">
              <button type="button" class="form_back prev_form1" @click="backFormStep">
                <span>
                  <i class="fas fa-chevron-left"></i>
                </span> Back
              </button>
              <button type="button" :disabled="step_six_invalid" @click="handleFormStep">
                Continue
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-else-if="form_step == 7">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>Deposit Structure</h1>
      </div>
      <div class="form-row">
        <div class="col-md-12 mb-4">
          <textarea
            class="form-control"
            placeholder="Enter deposite structure"
            name="deposite_structure"
            rows="10"
            v-model="deposite_structure"
          />
        </div>
        <div class="col-md-12">
          <div class="form_submit_button">
            <button type="button" class="form_back prev_form1" @click="backFormStep">
              <span>
                <i class="fas fa-chevron-left"></i>
              </span> Back
            </button>
            <button type="button" :disabled="step_seven_invalid" @click="handleFormStep">
              Continue
              <span>
                <i class="fas fa-chevron-right"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="form_step == 8">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>What is your home building type?</h1>
      </div>
      <form action="#">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio1"
                name="building_type"
                v-model="building_type"
                class="custom-control-input"
                value="Detached"
              />
              <label class="custom-control-label" for="customRadio1">Detached</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="building_type"
                v-model="building_type"
                class="custom-control-input"
                value="Semi detached"
              />
              <label class="custom-control-label" for="customRadio2">Semi detached</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="building_type"
                v-model="building_type"
                class="custom-control-input"
                value="Town house"
              />
              <label class="custom-control-label" for="customRadio2">Town house</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="building_type"
                v-model="building_type"
                class="custom-control-input"
                value="Apartment"
              />
              <label class="custom-control-label" for="customRadio2">Apartment</label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form_submit_button">
              <button type="button" class="form_back prev_form1" @click="backFormStep">
                <span>
                  <i class="fas fa-chevron-left"></i>
                </span> Back
              </button>
              <button type="button" :disabled="step_eight_invalid" @click="handleFormStep">
                Continue
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-if="form_step == 9">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>Let’s verify some fact about your home</h1>
      </div>
      <form action="#">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <input
              type="text"
              class="form-control"
              placeholder="Bedrooms (e.g. 1-3)"
              name="bedrooms"
              v-model="bedrooms"
            />
          </div>
          <div class="col-md-12 mb-4">
            <input
              type="text"
              class="form-control"
              placeholder="Bathrooms (e.g. 1-3)"
              name="bathrooms"
              v-model="bathrooms"
            />
          </div>
          <div class="col-md-12 mb-4">
            <input
              type="text"
              class="form-control"
              placeholder="Area in sqft (e.g. 500-1000)"
              name="sqft_area"
              v-model="sqft_area"
            />
          </div>
          <div class="col-md-12 mb-4">
            <input
              type="text"
              class="form-control"
              placeholder="Area in sqft (e.g. 500-1000)"
              name="sqft_area"
              v-model="sqft_area"
            />
          </div>
          <div class="col-md-12 mb-4">
            <input
              type="text"
              class="form-control"
              placeholder="Est completion date (dd/mm/yyyy)"
              name="completion_date"
              v-model="completion_date"
            />
          </div>
          <div class="col-md-12">
            <div class="form_submit_button">
              <button type="button" class="form_back prev_form1" @click="backFormStep">
                <span>
                  <i class="fas fa-chevron-left"></i>
                </span> Back
              </button>
              <button type="button" :disabled="step_nine_invalid" @click="handleFormStep">
                Continue
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-else-if="form_step == 10">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>What type of covered parking spaces does your home have?</h1>
      </div>
      <form action="#">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio1"
                name="type_of_parking"
                v-model="type_of_parking"
                class="custom-control-input"
                value="Garage"
              />
              <label class="custom-control-label" for="customRadio1">Garage</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="type_of_parking"
                v-model="type_of_parking"
                class="custom-control-input"
                value="Carport"
              />
              <label class="custom-control-label" for="customRadio2">Carport</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="type_of_parking"
                v-model="type_of_parking"
                class="custom-control-input"
                value="none"
              />
              <label class="custom-control-label" for="customRadio2">None of the above</label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form_submit_button">
              <button type="button" class="form_back prev_form1" @click="backFormStep">
                <span>
                  <i class="fas fa-chevron-left"></i>
                </span> Back
              </button>
              <button type="button" :disabled="step_ten_invalid" @click="handleFormStep">
                Continue
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-else-if="form_step == 11">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>What kind of exterior your house have?</h1>
      </div>
      <form action="#">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio1"
                name="exterior"
                v-model="exterior"
                class="custom-control-input"
                value="Brick"
              />
              <label class="custom-control-label" for="customRadio1">Brick</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="exterior"
                v-model="exterior"
                class="custom-control-input"
                value="Aluminum siding"
              />
              <label class="custom-control-label" for="customRadio2">Aluminum siding</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="exterior"
                v-model="exterior"
                class="custom-control-input"
                value="Stucco"
              />
              <label class="custom-control-label" for="customRadio2">Stucco</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="exterior"
                v-model="exterior"
                class="custom-control-input"
                value="Other"
              />
              <label class="custom-control-label" for="customRadio2">Other</label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form_submit_button">
              <button type="button" class="form_back prev_form1" @click="backFormStep">
                <span>
                  <i class="fas fa-chevron-left"></i>
                </span> Back
              </button>
              <button type="button" :disabled="step_eleven_invalid" @click="handleFormStep">
                Continue
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-else-if="form_step == 12">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>What is the status of your basement?</h1>
      </div>
      <form action="#">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio1"
                name="basement"
                v-model="basement"
                class="custom-control-input"
                value="Finished"
              />
              <label class="custom-control-label" for="customRadio1">Finished</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="basement"
                v-model="basement"
                class="custom-control-input"
                value="Finished Apartment"
              />
              <label class="custom-control-label" for="customRadio2">Finished Apartment</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="basement"
                v-model="basement"
                class="custom-control-input"
                value="Partially Finished"
              />
              <label class="custom-control-label" for="customRadio2">Partially Finished</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="basement"
                v-model="basement"
                class="custom-control-input"
                value="Unfinished"
              />
              <label class="custom-control-label" for="customRadio2">Unfinished</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="basement"
                v-model="basement"
                class="custom-control-input"
                value="No Basement"
              />
              <label class="custom-control-label" for="customRadio2">No Basement</label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form_submit_button">
              <button type="button" class="form_back prev_form1" @click="backFormStep">
                <span>
                  <i class="fas fa-chevron-left"></i>
                </span> Back
              </button>
              <button type="button" :disabled="step_twelve_invalid" @click.prevent="">
                Continue
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
  </div>
</template>

<script>
export default {
  name: "AddPropertyForm",
  data() {
    return {
      form_step: 1,
      relationship_with_property: "",
      builder_name: "",
      builder_address: "",
      project_name: "",
      project_city: "",
      state: "",
      zip: "",
      neighborhood: "",
      intersection: "",
      sales_center_address: "",
      builder_website: "",
      architect: "",
      marketing_company: "",
      interior_designers: "",
      brokerage: "",
      type_of_home: "",
      building_status: "",
      min_price: "",
      max_price: "",
      units: "",
      maintenance_charge: "",
      parking: "",
      price_per_sqft: "",
      deposite_structure: "",
      building_type: "",
      bedrooms: "",
      bathrooms: "",
      sqft_area: "",
      completion_date: "",
      type_of_parking: "",
      exterior: "",
      basement: "",
    };
  },
  methods: {
    handleFormStep() {
      this.form_step = this.form_step + 1;
    },
    backFormStep() {
      if(this.form_step > 1) {
        this.form_step = this.form_step - 1;
      }
    },
  },
  computed: {
    step_one_invalid() {
      return false;
    },
    step_two_invalid() {
      return false;
    },
    step_three_invalid() {
      return false;
    },
    step_four_invalid() {
      return false;
    },
    step_five_invalid() {
      return false;
    },
    step_six_invalid() {
      return false;
    },
    step_seven_invalid() {
      return false;
    },
    step_eight_invalid() {
      return false;
    },
    step_nine_invalid() {
      return false;
    },
    step_ten_invalid() {
      return false;
    },
    step_eleven_invalid() {
      return false;
    },
    step_twelve_invalid() {
      return false;
    },
  }
};
</script>
